<template>
<div class="chapter">
<div class="inner_page">
<p class="part"><b>PART 1</b></p>
<p class="part1"><b>UTAH</b></p>
<p class="center"><i>I prophesied that the Saints would continue to suffer much affliction and would be driven to the Rocky Mountains, many would apostatize, others would be put to death by our persecutors or lose their lives in consequence of exposure or disease, and some of you will live to go and assist in making settlements and build cities and see the Saints become a mighty people in the midst of the Rocky Mountains.</i><sup><span href="#/notes#ft-2" id="ft_2" title="Link target outside of Sample">2</span></sup></p>
<p class="center"><i>–Joseph Smith</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?9f23b8b8